
  import { css } from 'lit';
  export const styles = css`:host{--elevation: var(--ig-dialog-elevation, var(--ig-elevation-0));--border-color: var(--ig-dialog-border-color, var(--ig-gray-300));--ig-theme: bootstrap;--ig-theme-variant: light}`;
  